<div *transloco="let t; lang: 'en|static'; read: 'themeable-multiple-search-input'"
  role="group"
  [attr.aria-label]="ariaLabel">
  <div class="multiple-search-input">
    <mat-label>
      <span>{{ label }}</span>

      <button *ngIf="selectedOptions.length > 0"
        mat-stroked-button
        class="mat-default mat-button-small"
        [attr.aria-label]="t('aria_clear', { name: label })"
        (click)="onRemoveAllOptions()">{{ t('clear') }}
      </button>
    </mat-label>

    <div class="chip-container"
      [ngClass]="{ 'input-focused': inputFocused, 'cdk-keyboard-focused': cdkKeyboardFocused }"
      (click)="searchInputElement.focus()">
      <ng-container *ngFor="let el of selectedOptions; let i = index">
        <accredible-chip class="new-chip-design"
          [removable]="true"
          aria-hidden="true"
          [tabIndexRemove]="-1"
          [data]="el[optionsLabelKey]"
          (remove)="onRemoveOption(el)">
        </accredible-chip>
      </ng-container>

      <input #searchInputElement
        type="text"
        [ngModel]="searchQueryNgModel"
        [placeholder]="selectedOptions.length > 0 ? '' : placeholder"
        (ngModelChange)="onSearchQueryChange($event.trim())"
        (focus)="setInputKeyboardFocus($event, true)"
        (blur)="setInputKeyboardFocus($event, false)">
    </div>
  </div>

  <div class="scroll-wrapper"
    [ngClass]="{'top-gradient': showTopGradient, 'bottom-gradient': showBottomGradient}">
    <div *ngIf="displayedOptions.length > 0; else noOptions"
      role="list"
      [attr.aria-label]="t('aria_filter_values')"
      tabindex="0"
      #scrollContainer
      class="scroll-container"
      (scroll)="onScroll($event.target)"
      (mouseleave)="onMouseLeaveScrollContainer()">

      <div *ngFor="let option of displayedOptions"
        class="option"
        role="checkbox"
        [class.selected]="selectedOptionsIds.includes(option.id)"
        [attr.aria-checked]="selectedOptionsIds.includes(option.id)"
        [class.highlighted]="option.id === highlightedOption?.id"
        (click)="toggleOption(option)"
        (mouseover)="onOptionHover(option)">
        <div class="option-checkbox">
          <mat-icon>check</mat-icon>
        </div>
        <div class="option-label">
          {{ option[optionsLabelKey] }}
        </div>
      </div>
    </div>
  </div>

  <ng-template #noOptions>
    <div class="no-options">
      {{ t('no_options') }}
    </div>
  </ng-template>

  <div #searchInputCopyElement
    class="input-copy-element">
  </div>
</div>
